import {useCallback, useState} from "react";

export default function useOpenState(initialState = false, disableBackdropClick = false) {
    const [open, setOpen] = useState(initialState);

    const openDialog = useCallback(() => setOpen(true), []);

    const handleClose = useCallback((_event, reason) => {
        if (!disableBackdropClick || (disableBackdropClick && reason !== "backdropClick")) {
            setOpen(false);
        }
    }, []);

    return [open, openDialog, handleClose];
}